import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
import {get_token, get_user_details} from "@/router";
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import axios from "axios";
import Swal from 'sweetalert2';
import { client_domain } from "@/main.js";
import { open_preview as open_file_preview } from "@/utils/file_preview";

export default {
components: {
    HomeNavBar,
    Multiselect
},
inject: ['client_features'],
data() {
    return ({
    title: "",
    description: "",
    file: null,
    grouped_tags: {},      // Use object if you're looping via (tags, category)
    selected_tags: new Map(),
    selected_categories: [],
    library_resources: [],
    loading: false,
    deletingId: null,
    loading_upload: false,
    user_details: {},
    dwypd_domain: false,
    preview_url: null,
    preview_type: null,
    loading_recent: false,
    loading_preview:false

    })
},
mounted() {
    this.user_details = get_user_details();
    this.fetch_grouped_tags();
    this.fetch_library_resources();
    if(client_domain.includes('dwypd')) {
        this.dwypd_domain = true;
    }
},
methods: {
 getToken() {
    return get_token();
    },
get_file_class(filename) {
  if (!filename) return "";

  const ext = filename.split('.').pop().toLowerCase();

  const map = new Map([
    ["pdf", "pdf"],
    ["doc", "doc"],
    ["docx", "doc"],
    ["xls", "xls"],
    ["xlsx", "xls"],
    ["ppt", "ppt"],
    ["pptx", "ppt"],
    ["txt", "txt"],
    ["png", "img"],
    ["jpg", "img"],
    ["jpeg", "img"]
  ]);

  return map.has(ext) ? map.get(ext) : "file";
},

get_file_label(filename) {
  if (!filename) return "File";

  const ext = filename.split('.').pop().toLowerCase();

  const map = new Map([
    ["pdf", "PDF"],
    ["doc", "DOCX"],
    ["docx", "DOCX"],
    ["xls", "Excel"],
    ["xlsx", "Excel"],
    ["ppt", "PPT"],
    ["pptx", "PPT"],
    ["txt", "TXT"],
    ["png", "JPEG"],
    ["jpg", "JPEG"],
    ["jpeg", "JPEG"]
  ]);

  return map.has(ext) ? map.get(ext) : "File";
},

  open_preview(document) {
    open_file_preview(this, document);
  },

 on_content_loaded() {
    this.loading_preview = false;
  },

  downloadFile(file) {
    const link = document.createElement("a");
    link.href = file.url;
    link.download = file.name || "file";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
fetch_library_resources() {
  this.loading = true;

  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_library_documents/`,
    method: 'POST',
    headers: {
      'Authorization': `Token ${this.getToken()}`,
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({ user_id: this.user_details?.user_id }),
    success: (response) => {
    if (response.status === "success") {
    this.library_resources = response.data;
    }
    },
    complete: () => {
      this.loading = false;
    }
  });
},

 delete_document(document_id) {

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_library_document/`,
        method: 'DELETE',
        headers: {  
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({ library_document_id: document_id }),
        success: (response) => {
          if (response.status === "success") { 
            this.library_resources = this.library_resources.filter(doc => doc.id !== document_id);
          }
        },
      });
    
  
},

handleFileUpload(event) {
    this.file = event.target.files[0];
},
   async submitLibraryResource() {
  this.loading_upload = true;

  const formData = new FormData();
  formData.append("title", this.title);
  formData.append("description", this.description);
  formData.append("file", this.file);

  const tag_ids = this.selected_categories.map(cat => cat.id);
  tag_ids.forEach(id => formData.append("tag_ids", id));

  const headersConfig = {
    headers: {
      Authorization: `Token ${this.getToken()}`,
    },
  };

  try {
    // ✅ Make the request and capture the response
    const response =await axios.post(
      `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_library_resource/`,
      formData,
      headersConfig

    );

    this.library_resources.unshift(response.data.data);

    // ✅ Reset form
    this.title = "";
    this.description = "";
    this.file = null;
    this.selected_categories = [];
    document.getElementById("document_file").value = null;

    // ✅ Close the modal
    $('#upload_modal').modal('hide');

    // ✅ Success message
    Swal.fire({
      icon: "success",
      title: "Uploaded!",
      text: "The document was uploaded successfully.",
      timer: 2000,
      showConfirmButton: false,
      position: 'bottom-end',
      toast: true
    });

  } catch (err) {
    console.error("Upload Error:", err.response?.data || err);

    Swal.fire({
      icon: "error",
      title: "Upload Failed",
      text: err.response?.data?.message || "Something went wrong. Please try again.",
      position: 'bottom-end',
      showConfirmButton: false,
      timer: 3000,
      toast: true
    });
  } finally {
    this.loading_upload = false;
  }
},

 preselectTagsFromFlatArray() {
  const preselected = this.existing_tags || []; // Flat array of tag objects

  preselected.forEach(tag => {
    const cat_id = tag.tag_category.id;
    if (this.selected_tags.has(cat_id)) {
      const current = this.selected_tags.get(cat_id) || [];
      current.push({ id: tag.id, name: tag.name });
      this.selected_tags.set(cat_id, current);
    }
  });

  // Force reactivity
  this.selected_tags = new Map(this.selected_tags);
},
updateTagSelection(categoryId, newValue) {
  this.selected_tags.set(categoryId, newValue);
  // Force reactivity
  this.selected_tags = new Map(this.selected_tags);
},
fetch_grouped_tags() {
  this.isLoading = true;

  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_tags/`,
    method: 'GET',
    headers: {
      'Authorization': `Token ${this.getToken()}`,
      'Content-Type': 'application/json'
    },
    success: (response) => {
      if (response.status === "success") {
        const tag_list = response.data.tags;

        // ✅ Use Map to group tags by category name
        const grouped = new Map();

        tag_list.forEach(tag => {
          const cat_id = tag.tag_category.id;
          const categoryName = tag.tag_category.name;

          if (!grouped.has(cat_id)) {
            grouped.set(cat_id,
              {
                id: cat_id, // Use category ID as the key
                name: categoryName,
                tags: []
              }
            );
          }

          grouped.get(cat_id).tags.push({
            id: tag.id,
            name: tag.name
          });
        });

        // ✅ Convert grouped Map to an array and store as grouped_tags
        this.grouped_tags = Array.from(grouped.values());


        this.grouped_tags.forEach(cat => {
          this.selected_tags.set(cat.id, []);
        });

        this.preselectTagsFromFlatArray();
      }
    },
    complete: () => {
      this.isLoading = false;
    }
  });
},
submit_tags() {
this.selected_categories = Array.from(this.selected_tags.values()).flat();
},
}
}
